import { render, staticRenderFns } from "./ModalPurchaseRequisitionsDetail.vue?vue&type=template&id=7effc7a7&lang=pug&"
import script from "./ModalPurchaseRequisitionsDetail.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseRequisitionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalPurchaseRequisitionsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports